import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, FromDictionaryPipe],
})
export class AuthLayoutComponent implements OnInit {
  @Input() prefix = '';
  @Input() intro?: string;
  @Input() title?: string;

  constructor() {}

  ngOnInit(): void {}
}
